import React from "react";
import { cn } from "../../lib/utils";

/**
 * Status badge tones — fully static class strings so Tailwind JIT picks them up.
 *
 * Dark mode is the calibrated reference: every tone uses translucent fill so
 * the dark surface shines through (like the destructive/Hoch reference),
 * with a clearly visible border in the same hue and a bright readable text.
 *
 * Light mode keeps the gentle tinted backgrounds with strong text.
 */
const TONE_CLASSES = {
  new:
    "bg-sky-50 text-sky-700 border-sky-200 " +
    "dark:bg-sky-500/15 dark:text-sky-300 dark:border-sky-500/40",
  info:
    "bg-blue-50 text-blue-700 border-blue-200 " +
    "dark:bg-blue-500/15 dark:text-blue-300 dark:border-blue-500/40",
  success:
    "bg-emerald-50 text-emerald-700 border-emerald-200 " +
    "dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/40",
  warning:
    "bg-amber-50 text-amber-800 border-amber-200 " +
    "dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/40",
  destructive:
    "bg-rose-50 text-rose-700 border-rose-200 " +
    "dark:bg-rose-500/15 dark:text-rose-300 dark:border-rose-500/40",
  muted:
    "bg-zinc-100 text-zinc-700 border-zinc-200 " +
    "dark:bg-white/[0.06] dark:text-zinc-300 dark:border-white/15",
};

export default function StatusPill({ tone = "muted", children, className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-medium",
        // backdrop-blur makes the translucent fill render consistently across browsers
        "backdrop-blur-[1px]",
        TONE_CLASSES[tone] || TONE_CLASSES.muted,
        className,
      )}
    >
      {children}
    </span>
  );
}
